import React from 'react';
import { List } from 'antd';
import { FolderOutlined, FileOutlined, ProjectOutlined, RightOutlined } from '@ant-design/icons';
import { getStatusColor, getStatusLabel } from '../../utils/statusHelpers';
import styles from './EntryResultItem.module.scss';

interface EntryResultItemProps {
  item: {
    id: number;
    name: string;
    entryType: string;
    path: string;
    status: string;
    projectName?: string;
    fileName?: string;
  };
  onItemClick: (item: any) => void;
}

const EntryResultItem: React.FC<EntryResultItemProps> = ({ item, onItemClick }) => {
  const getEntryIcon = (entryType: string) => {
    switch (entryType) {
      case 'Project':
        return <ProjectOutlined />;
      case 'Folder':
        return <FolderOutlined />;
      case 'File':
        return <FileOutlined />;
      case 'Version':
        return <FileOutlined />;
      default:
        return <ProjectOutlined />;
    }
  };

  const formatPathDisplay = (item: any) => {
    // API'den gelen projectName ve fileName varsa onları kullan
    if (item.projectName && item.fileName) {
      if (item.entryType === 'Version') {
        return `${item.projectName} - ${item.fileName} - ${item.name}`;
      } else {
        return `${item.projectName} - ${item.fileName}`;
      }
    }
    
    // Eğer projectName ve fileName yoksa sadece name'i göster
    return item.name;
  };

  const pathDisplay = formatPathDisplay(item);

  return (
    <List.Item 
      className={styles.resultItem}
      onClick={() => onItemClick(item)}
    >
      <div className={styles.itemContent}>
        <div className={styles.itemInfo}>
          <div className={styles.itemTitle}>
            <span className={styles.entryIcon} style={{ color: 'var(--app-accent-color)' }}>
              {getEntryIcon(item.entryType)}
            </span>
            <span className={styles.itemTitleText} title={pathDisplay}>
              {pathDisplay}
            </span>
          </div>
        </div>
        <div className={styles.itemArrow}>
          <span 
            className={styles.statusBadge}
            style={{ 
              backgroundColor: getStatusColor(item.status),
              color: '#F6FFED',
              padding: '2px 8px',
              borderRadius: '999px',
              fontSize: '8px',
              fontWeight: 700,
              marginRight: '8px'
            }}
          >
            {getStatusLabel(item.status)}
          </span>
          <RightOutlined className={styles.arrowIcon} />
        </div>
      </div>
    </List.Item>
  );
};

export default EntryResultItem; 